import React, { useEffect } from "react";
import "./CustomModal.css";

const CustomModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  footerButtons = [],
  formErrorMessage,
  formwarningMessage,
  width = 70,
  height = 90,
}) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const getButtonClassName = (style) => {
    switch (style) {
      case "primary":
        return "custom-modal-button primary";
      case "red":
        return "custom-modal-button red";
      case "grey":
        return "custom-modal-button grey";
      case "warning":
        return "custom-modal-button warning";
      default:
        return "custom-modal-button";
    }
  };

  return (
    <div className="custom-modal-overlay" onClick={onClose}>
      <div
        className="custom-modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: `${width}%`,
          height: `${height}%`,
        }}
      >
        <div className="custom-modal-header">
          <div className="custom-modal-header-content">
            <div className="custom-modal-title-container">
              {title && (
                <h2
                  className="custom-modal-title"
                  style={{ marginBottom: "0px" }}
                >
                  {title}
                </h2>
              )}
              {formErrorMessage && (
                <span className="custom-modal-badge error">
                  {formErrorMessage}
                </span>
              )}
              {formwarningMessage && (
                <span className="custom-modal-badge warning">
                  {formwarningMessage}
                </span>
              )}
            </div>
            {subtitle && <p className="custom-modal-subtitle">{subtitle}</p>}
          </div>
          <button className="custom-modal-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="custom-modal-body">{children}</div>
        {footerButtons.length > 0 && (
          <div className="custom-modal-footer">
            {footerButtons.map((button, index) => (
              <button
                key={index}
                className={getButtonClassName(button.style)}
                onClick={button.onClick}
                disabled={button.disabled}
              >
                {button.title}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomModal;
